// extracted by mini-css-extract-plugin
export default {"productGallery":"FH-z","inQuickShop":"GH-z"};